<template>
  <div ref="wrapper" class="scroll_wrap_overflow">
    <div ref="scrollWidth" class="scroll_content">
      <div class="scroll_wrap">
        <div
            v-for="(item, index) in showImages"
            :key="index"
            class="scroll_item"
        >
          <div class="scroll_img">
            <img ref="curImg" :src="item.src" alt=""/>
          </div>
          <div class="scroll_txt">{{ item.txt }}</div>
        </div>
      </div>
    </div>
    <!-- <div class="scroll_bottom_btn" @click="handleToDemo">
      <el-button class="bottom_btn" round
      >预览智能工业装备大脑demo
      </el-button
      >
    </div> -->
  </div>
</template>

<script>
import BScroll from 'better-scroll'

export default {
  data() {
    return {
      showImages: [
        {
          src: require('@/assets/img/53.png'),
          txt: '产业大脑赋能经济发展，产业雷达、一键入园双发布，智能工业装备创造助力产业数字化改革',
        },

        {
          src: require('@/assets/img/51.png'),
          txt: '智能工业装备产业大脑从生物医药向人工智能、新材料、新能源汽车等战略性新兴产业延伸',
        },
        {
          src: require('@/assets/img/202209077076.png'),
          txt: 'MES系统通过数字化与智能化技术，赋能制造业转型升级，助力企业实现生产流程优化、效率提升与质量管控。',
        },
          {
          src: require('@/assets/cdz.png'),
          txt: '通过全新智能充电设备，提升充电效能，实现智能化充电管理。利用先进技术优化充电速度与安全性，为用户提供更高效、便捷的充电体验。',
        },
      ],
      scroll: null,
    }
  },
  mounted() {
    //创建BScroll对象并设置参数
    this.scroll = new BScroll(this.$refs.wrapper, {
      disableMouse: false, //启用鼠标拖动
      disableTouch: false, //启用手指触摸
      scrollX: true, //X轴滚动启用
      eventPassthrough: 'vertical'
    })
    const scrollXEnd = (this.showImages.length - 2) * this.$refs.curImg[0].width
    this.$refs.scrollWidth.style.width = this.showImages.length * this.$refs.curImg[0].width + 100 + 'px'
    this.scroll.refresh()
    this.scroll.scrollTo(-scrollXEnd, 0, 10000)
    setTimeout(() => {
      this.scroll.scrollTo(0, 0, 10000)
    }, 10000)
  },
  methods: {
    handleToDemo() {
      this.$router.push('/demo')
    },
  },
}
</script>

<style lang="scss" scoped>
.scroll_wrap_overflow {
  width: 70%;
  margin: 0 auto;
  overflow: hidden;
  @media screen and (max-width: 768px) {
    width: 90%;
  }

  .scroll_content {
    .scroll_wrap {
      width: 100%;
      display: flex;
      @media screen and (max-width: 768px) {
        width: 100%;
        display: flex;
      }

      .scroll_item {
        width: 450px;
        margin-top: 30px;
        margin-right: 30px;
        flex-shrink: 0;
        @media screen and (max-width: 768px) {
          width: 180px;
          margin-right: 20px;
        }

        .scroll_img {
          width: 100%;
          @media screen and (max-width: 768px) {
            width: 180PX;
          }

          img {
            width: 100%;
            @media screen and (max-width: 768px) {
              width: 100%;
            }
          }
        }

        .scroll_txt {
          color: #646464;
          font-size: 16px;
          margin-top: 30px;
          @media screen and (max-width: 768px) {
            font-size: 15px;
            width: 180PX;
          }
        }
      }
    }
  }

  .scroll_bottom_btn {
    text-align: center;

    .bottom_btn {
      margin-top: 70px;
      background: orange;
      color: #fff;
      font-size: 13px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        border-radius: 20px;
        width: 140px;
        height: 40px;
        font-size: 14px;
      }
    }
  }
}
</style>